<template>
  <el-row>
    <el-col :span="24">
      <div>
        <!-- <div class="datails_nav">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">
                <i class="el-icon-s-home" />首页
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/creativeTalents' }">
                成果研发专家
                </el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div class="detail_top_info_box">
          <div class="top_info_box">
            <div class="top_info_box_left">
              <video controls :src="university.url"></video>
            </div>
            <div class="top_info_box_right">
              <div class="top_info_name">{{ university.name
 }}</div>
              <div class="top_info_desc">
                <label>发布时间：</label
                >{{
                  university.createDate
                    ? university.createDate.substring(0, 10)
                    : ""
                }}
              </div>
              <div class="top_info_desc">
                <label>播 放 量：</label>{{ university.PlaybackVolume }}
              </div>
              <div class="top_info_desc">
                <label>关联成果：</label>
                <span style="cursor: pointer;" @click="tz(university.achievementId)">{{ university.Title }}</span>
              </div>
              <div class="top_info_desc">
                <label>主 讲 人：</label>{{ university.speaker }}
              </div>
              <div class="top_info_desc">
                <label>单位名称：</label
                >{{ university.CollegesUniversitiesName }}
              </div>
              <div class="top_info_desc"><label>技术领域：</label></div>
              <div class="top_info_desc">
                <label>联系方式：</label>{{ university.speakerPhone }}
              </div>
              <div class="top_info_sub_title">主讲人简介：</div>
              <div class="top_info_txt">
                {{ university.speakerIntroduction }}
              </div>
              <div class="top_info_btn" @click="openAppeal">我要对接</div>
            </div>
          </div>
        </div>
        <div class="detail_body_info_box">
          <div class="body_info_box">
            <div class="detail_body_info_left">
              <div class="detail_body_header">
                <div class="detail_body_header_box">
                  <div class="detail_body_header_title">
                    成果<span>介绍</span>
                  </div>
                </div>
              </div>
              <div
                class="detail_body_info_content"
               
              >
                <div class="detail_body_info_txt" v-html="university.DetailsOfTheResults">
                </div>
                <!-- <div class="detail_body_info_sub_title">视频相关文件：</div>
                <div
                  class="detail_body_info_file"
                  v-for="index in 3"
                  :key="index"
                >
                  <div class="file_name">
                    附件1:双氧水装置高产低耗的工艺流程.png
                  </div>
                  <div class="file_oper">
                    <div class="file_oper_btn">预览</div>
                    <div class="file_oper_btn">下载</div>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="detail_body_info_right">
              <div class="detail_body_header">
                <div class="detail_body_header_box">
                  <div class="detail_body_header_title">
                    全部<span>留言</span>
                  </div>
                  <div class="detail_tag_box">
                    <div class="tag_item " :class="msgParam.leveaType == '1' ? 'tag_active' : ''" @click="changLeveaType('1')">最新</div>
                    <div class="tag_item" :class="msgParam.leveaType == '0' ? 'tag_active' : ''" @click="changLeveaType('0')">热门</div>
                  </div>
                </div>
                <div class="answer_box">
                  <div style="text-align:left;" v-for="(item,index) in msgLi " :key="index" >
                    <div class="answer_item">
                    <div class="answer_avatar">
                      <img src="@/assets/lectureRoom/avatar.png" />
                    </div>
                    <div class="answer_content">
                      <div class="answer_top">
                        <div class="answer_name">{{ item.RealName }}</div>
                        <div class="answer_time">{{item.Create_time}}</div>
                      </div>
                      <div class="answer_txt"> {{item.Content}}</div> 
                      <ul class="commentList" v-for="(item, index) in item.children"   :key="index">
                    <li >
                      <div class="answer_item">
                    <div class="answer_avatar">
                      <img src="@/assets/lectureRoom/avatar.png" />
                    </div>
                <div>
                      <div class="op">
                        <div class="answer_name">{{ item.RealName }}</div>
                        <div class="answer_time">{{item.Create_time}}</div>
                      </div>
                      <div class="txt"> {{item.Content}}</div> </div>
                      <!-- <p>
                         <span class="commentName">{{ item.RealName }} ：</span>
                        <span class="commentText">{{ item.Content }}</span>
                      </p>
                       <p class="commentTime">{{ item.Create_time
.substring(0, 10) }}</p> -->
                    </div>
                    </li>
                  </ul>
                
               <div class="islike">
                    <p class="comment" @click="comment">
                      <img src="../../../assets/images/组 24783@2x.png" alt />
                      <span>回复</span>
                    </p>
                  </div> 
                      
                    
                    </div>
                  </div>
                  </div>
                 
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail_body_info_box" v-if="xgList.length >0">
          <div class="about_info_box">
            <div class="detail_body_header">
              <div class="detail_body_header_box">
                <div class="detail_body_header_title">
                  相关<span>推荐</span>
                </div>
              </div>
            </div>
            <div class="about_box">
              <div class="about_item" v-for="(item,index) in xgList .slice(0, 4)" :key="index" @click="videoo(item.id)">
                <div class="about_item_img">
                  <img :src="item.CoverImage"/>
                </div>
                <div class="about_item_content">
                  <div class="about_item_title">{{item.Title}}</div>
                  <div class="about_item_desc">发布时间：{{item.createDate}}</div>
                  <div class="about_item_desc">流量次数：{{item.PlaybackVolume}}</div>
                  <div class="about_item_txt">
                   {{ item.speakerIntroduction }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else></div>
      </div>
    </el-col>
    <el-dialog
   
      :visible.sync="openMore"
      custom-class="open_more_dialog_box"
      width="40rem"
      :close-on-click-modal="false"
    >
      <div class="open_more_dialog">
        <div class="open_more_dialog_top">
          <div class="open_more_dialog_name">我要对接</div>
        </div>
        <div class="open_more_dialog_body">
          <el-form :mode="appealForm" ref="appealForm">
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item>
                  <el-input placeholder="请输入您的姓名" v-model="appealForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-input placeholder="请输入您的单位" v-model="appealForm.unit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item>
                  <el-input placeholder="请输入您的职务" v-model="appealForm.duties"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-input placeholder="请输入您的联系方式" v-model="appealForm.contactInformation"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                  v-model="appealForm.content"
                    type="textarea"
                    placeholder="请输入对接内容..."
                    rows="4"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="open_more_dialog_footer">
          <div class="open_more_dialog_btn" @click="submitAppeal">
            确定对接
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
  
      :visible.sync="openMore1"
      custom-class="open_more_dialog_box"
      :close-on-click-modal="false"
      width="40rem"
    >
      <div class="open_more_dialog">
        <div class="open_more_dialog_top">
          <div class="open_more_dialog_name">我要回复</div>
        </div>
        <div class="open_more_dialog_body">
          <el-form :mode="appealFormm" ref="appealFormm">
            
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                  v-model="appealFormm.content"
                    type="textarea"
                    placeholder="请输入回复内容..."
                    rows="4"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="open_more_dialog_footer">
          <div class="open_more_dialog_btn" @click="submitAppeal1">
            确定回复
          </div>
        </div>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import { getAction, postAction } from "@/api/api";
import empty from "@/components/empty.vue";
import Docking from '@/components/Docking.vue'
import Pagination from "../components/Pagination/paginationpro.vue";
import qs from "qs";
import {
  fruitChoose,
  library,
  CollegesHandler,
  Talent,
  VideoLectureHallHandle,
  docking,
} from "@/api/url";
import Empty from "../../../components/empty.vue";

export default {
  name: "Organization",
  data() {
    
    return {
      dockShow: false,
      appealFormm: {
        action: "lectureRoomLYAdd",
        userid:'',
        projectid: this.$route.query.id,
        content: "",
        type: "8",
        ParentId: "2285",
        name:"",
        unit:"",
        duties:"",
        contactInformation:"",
      },
      appealForm: {
        action: "lectureRoomLYAdd",
        userid:'',
        projectid: this.$route.query.id,
        content: "",
        type: "8",
        ParentId: "0",
        name:"",
        unit:"",
        duties:"",
        contactInformation:"",
      },
      appealForm1: {
        action: "lectureRoomLYAdd",
        userid:'',
        projectid: this.$route.query.id,
        content: "",
        type: "8",
        ParentId: "",
        name:"",
        unit:"",
        duties:"",
        contactInformation:"",
      },
      appealRule: {
        unit: [{ required: true, message: "请输入您的单位", trigger: "blur" }],
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        duties: [
          { required: true, message: "请输入您的职务", trigger: "blur" },
        ],
        contactInformation: [
          { required: true, message: "请输入您的联系方式", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入诉求内容", trigger: "blur" },
        ],
      },
      //转换第一帧
      // cutPicture(item) {
      //   let video = document.createElement("video");
      //   video.style = 'position:fixed; top: 9999px;left:9999px;z-index:-9999'
      //   video.preload = 'metadata'
      //   video.currentTime = 1   //截取的视频第一秒作为图片
      //   video.src = item.videoUrl
      //   video.setAttribute('crossOrigin', 'anonymous');
      //   video.width = 113
      //   video.height = 75
      //   document.body.appendChild(video)
      //   video.onloadeddata = function () {
      //     let canvas = document.createElement('canvas')
      //     canvas.width = 113
      //     canvas.height = 75
      //     canvas.getContext('2d').drawImage(video, 0, 0, video.clientWidth, video.clientHeight)
      //     var oGrayImg = canvas.toDataURL('image/jpeg');
      //     item.videoUrl = oGrayImg
      //     this.remove()
      //   }
      //   return item
      // },

      //人才库参数

      total: 0,
      //人才库列表
      itemList: [],
      spParams: {
        action: "GetModelByIdPc",
        id: this.$route.query.id,
      },
      spParams1:{
    action:'GetPageListPC',
    name:'',
    page:1,
    sort:'ah.createDate DESC',
   
        limit:8,
   },
      total: 1,
      xgList:[],

      sortA: false, //综合排序
      university: {},
      talrowetList: [], //
      openMore: false,
      openMore1: false,
      talcltList: [], //热门需求
      searchForm: {
        action: "Get_AchievementList",
        pageSize: 10, //一页多少条
        page: 1, //	第几页
        strSort: "", // 	//发布时间 上 a.UpdateTime ASC //发布时间 下 a.UpdateTime DESC //热度 上 b.ClickRank ASC //热度 下 b.ClickRank DESC //金额 上 a.InvestInFunds ASC //金额 下 a.InvestInFunds DESC
        strTechFieldEnum: "", //	技术领域id
        strPropertystatus: "", //	知识产权状况id
        strProjectPhase: "", //	项目阶段id
        strCooperaType: "", //	合作方式id
        strBudgetary: "", //	投入资金id
        strtitle: "", // 	搜索关键字
        strCountries: "", //	0：国内 1：国外
        strCitys: "", //	国内-省市ID
        strCountryText: "", //	国外-国家ID
      },
      pParams: {
        action: "AddPlaybackVolume",
        id: this.$route.query.id,
      },
      TechFieldEnumArr: [],
      TechA: null, // 技术激活
      openLineTech: false, // 技术展开
      KonwA: "", // 技术激活
      LogoUrl: "",
      VideoUrl: "",
      CollegesUniversitiesName: "",
      EducationalLevel: "",
      EducationalType: "",
      Synopsis: "",
      tjiu: null, //技术库
      child: null, //国家
      sortin: null, //排序
      istrue: false, //时间排序
      isroung: false, //热度排序
      // openMore: true,
      videoUrl: "",
      radio1: "最新",
      msgParam:{
        action:'GetHotLeaveMsg',
        projectId:this.$route.query.id,
        type:'8',
        leveaType:'1'
      },
      msgLi:[],
  
      msgList:[]
    };
  },
  props: {},
  components: {
    Pagination,
    Empty,
     Docking
  },
  created() {
    this.head();
    this.head1();
    this.head3();
    // this.$bus.$emit("ChangeFocus", 3);
    // window.localStorage.setItem("NowIndex", 5);
    // if (this.$route.query.type) {
    //   this.TechA = this.$route.query.type;
    //   this.taleget.strTechField = this.$route.query.type;
    // }
    // console.log("+++++++", this.taleget.pageSize);
    //列表
    // this.talentList();
  
    // console.log("docking", this.DialogVisible);
    // this.UserID = localStorage.getItem('RealID');
    // console.log('成果厅详情type',this.type)
    // console.log('成果厅详情pjid',this.id)

    //lost
    this.getDock()
  },
  mounted() {
    // this.$bus.$on("LoginSuccess", (e) => {
    //   if (e) {
    //     this.talentList();
    //   }
    // });
    // this.getChoose();
  },
  methods: {
    openAppeal() {
      // this.openMore = true;
      // this.$nextTick(() => {
      //   this.$refs.appealForm.clearValidate();
      // });
      let RealName = localStorage.getItem('RealName')
      if (RealName == '') {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        this.openMore = true;
        this.$nextTick(() => {
        this.$refs.appealForm.clearValidate();
      });
        //// console.log(this.dockShow);
      }
    },
    changLeveaType(type){
      this.msgParam.leveaType = type
      this.getDock()
    },
    getDock(){
      getAction(docking,this.msgParam).then(res=>{
        console.log(res)
        this.msgLi = res.data;
   
      })
    },
    getChoose() {
      this.getTechFieldEnum();
    },
    getTechFieldEnum() {
      let data = {
        action: "Achievements_getfields",
        ParentName: "TechFieldEnum",
      };
      getAction(fruitChoose, data).then((res) => {
        res.map((item) => {
          this.TechFieldEnumArr.push(item);
        });
      });
    },
    // openAppeal11() {
    //   this.openMore1 = true;
    //   this.$nextTick(() => {
    //     this.$refs.appealFormm.clearValidate();
    //   });
    // },
       //评论
       comment(a) {
      //// console.log(a); //列表的ID
      this.ParentId = Number(a)

      let RealName = localStorage.getItem('RealName')
      let vm = this

      // 判断是否登录
      if (RealName == '') {
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        // 打开弹框
        this.openMore1 = true;
        this.$nextTick(() => {
        this.$refs.appealFormm.clearValidate();
      });
        // //// console.log("需求详情我要对接的ProjectID", this.ProjectID);
        // //// console.log("点击了yunDetail我要对接")
        // //// console.log('this.DialogVisible',this.dDialogVisible)
      }
    },

    //搜索清除
    clearVal() {
      this.talentList();
    },
    recomSort(n) {
      this.sortin = n;
      this.taleget.strSort = "";
      this.isroung = false;
      this.istrue = false;
      this.talentList();
    }, // 综合排序
    timeSort(n) {
      this.sortin = n;
      this.istrue = !this.istrue;
      if (this.istrue) {
        this.taleget.strSort = "a.UpdateDate DESC";
      } else {
        this.taleget.strSort = "a.UpdateDate ASC";
      }
      this.isroung = false;
      this.talentList();
    }, //时间排序
    hotSort(n) {
      this.sortin = n;
      this.isroung = !this.isroung;
      if (this.isroung) {
        this.taleget.strSort = " a.ClickRank DESC";
      } else {
        this.taleget.strSort = " a.ClickRank ASC";
      }
      this.istrue = false;
      this.talentList();
    }, // 热度排序
    // 切换计划标签
    changeTech(item) {
      this.TechA = item;
      this.taleget.strTechField = item;
      this.taleget.page = 1;
      this.talentList();
    },
    // 技术更多
    openMoreTech() {
      this.openLineTech = !this.openLineTech;
    },
    //数据列表
    talentList() {
      for (let i = 0; i < 10; i++) {
        this.itemList.push({
          ID: i,
          LogoUrl:
            "https://images.shobserver.com/news/690_390/2024/01/23/l_cb20240123170403602052.jpg",
        });
      }
      // getAction(CollegesHandler, this.taleget).then((res) => {
      //   this.itemList = res.data;
      //   this.total = res.count;
      // });
    },
    head() {
      getAction(VideoLectureHallHandle, this.spParams).then((res) => {
        console.log("111");
        this.university = res.data;
        this.spParams1. CollegesUniversitiesGUID = res.data.affiliationFacultyId
        getAction(VideoLectureHallHandle, this.spParams1).then((res) => {
        console.log("111");
        this.xgList = res.data;
      });
      });
    },
    head1() {
      getAction(VideoLectureHallHandle, this.pParams).then((res) => {
        console.log("111");
        this.itemListt = res.data;
      });
    },
    // head3() {
    //   getAction(VideoLectureHallHandle, this.spParams1).then((res) => {
    //     console.log("111");
    //     this.xgList = res.data;
    //   });
    // },
    //专家库
    tquan(n) {
      this.tjiu = n;
      this.taleget.page = 1;
      if (n == null) {
        this.taleget.strCategory = "";
        this.talentList();
        return;
      }
      this.taleget.strCategory = n;
      this.talentList();
    },
    //国家
    chilerd(int) {
      this.child = int;
      this.taleget.page = 1;
      if (int == null) {
        this.taleget.strprovince = "";
        this.talentList();
        return;
      }
      this.taleget.strprovince = int;
      this.talentList();
    },
    //搜索
    hadsoun() {
      this.talentList();
      this.$refs.basicInformation.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
    //搜索回车事件
    keyup() {
      let evt = window.event.keyCode;
      if (evt == 13) {
        this.talentList();
      }
    },
    //成果跳转详情
    talent(id) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/schoolInfo",
          query: { list: id },
        });
        window.open(routeData.href, "_blank");
      } else {
        window.location.href =
          this.Urls + "/Mobile/index.html#/TalentPoolDetail?id=" + id;
        // this.$router.push({
        //   path:
        //     'http://www.nttzzc.com/Mobile/index.html#/TalentPoolDetail?id=' +
        //     id,
        // })
      }
    },
    //标题跳转
    tz(id) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/fruittDetail",
          query: { id: id },
        });
        window.open(routeData.href, "_blank");
      } else {
        window.location.href =
          this.Urls + "/Mobile/index.html#/TalentPoolDetail?id=" + id;
        // this.$router.push({
        //   path:
        //     'http://www.nttzzc.com/Mobile/index.html#/TalentPoolDetail?id=' +
        //     id,
        // })
      }
    },
    //需求跳转详情
    crtto(id) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/demandDetail",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      } else {
        window.location.href =
          this.Urls + "/Mobile/index.html#/NeedPoolDetail?id=" + id;
        // this.$router.push({
        //   path:
        //     'http://www.nttzzc.com/Mobile/index.html#/NeedPoolDetail?id=' + id,
        // })
      }
    },
    submitAppeal() {
      this.openMore = false
      console.log(this.appealForm);
      console.log(this.$refs.appealForm);
      // this.UserID = localStorage.getItem('RealID')
      // this.$refs.appealForm.validate((valid) => {
      //   if (valid) {
      postAction(docking, this.$qs.stringify(this.appealForm)).then(
        (res) => {
          console.log(res);
        }
     
      );
      console.log("1122");
      //   } else {
      //     console.log("AppealHandle");
      //   }
      // });
    },
    submitAppeal1() {
      this.openMore1 = false
      
      // this.UserID = localStorage.getItem('RealID')
      // this.$refs.appealForm.validate((valid) => {
      //   if (valid) {
      postAction(docking, this.$qs.stringify(this.appealFormm)).then(
        (res) => {
          console.log(res);
        }
     
      );
      console.log("1122");
      //   } else {
      //     console.log("AppealHandle");
      //   }
      // });
    },
    hf(){
      postAction(docking, this.$qs.stringify(this.appealForm1)).then(
        (res) => {
          console.log(res);
        }
     
      );
    },
    videoo(id) {
        //判断是否是PC设备，true是，false不是
        let userAgentInfo = navigator.userAgent
        let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
        let flag = true
        for (let j = 0; j < Agents.length; j++) {
          if (userAgentInfo.indexOf(Agents[j]) > 0) {
            flag = false
            break
          }
        }
        if (window.screen.width >= 768) {
          flag = true
        }
        if (flag) {
          let routeData = this.$router.resolve({
            path: '/lectureRoomDetail',
            query: { id: id },
          })
          window.open(routeData.href, '_blank')
        } else {
          window.location.href=this.Urls+'/Mobile/index.html#/TalentPoolDetail?id=' + id
          // this.$router.push({
          //   path:
          //     'http://www.nttzzc.com/Mobile/index.html#/TalentPoolDetail?id=' +
          //     id,
          // })
        }
      },
    filters: {
      // filterTime为过滤器名字
      filterTime(data, format) {
        // data 为管道符前面的数据   format 为传送的参数
        // 获取年份
        let year = data.getFullYear();
        // 获取月份加一然后转为字符串，用 padStart方法补零
        let months = (data.getMonth() + 1).toString().padStart(2, "0");
        let days = data.getDate();
        // let hours = (data.getHours() + 1).toString().padStart(2, '0');
        // let minutes = (data.getMinutes() + 1).toString().padStart(2, '0');
        // let seconds = (data.getSeconds() + 1).toString().padStart(2, '0');
        // 将传入的参数替换为获取的日期，链式调用，最后返回
        return format
          .replace("YYYY", year)
          .replace("MM", months)
          .replace("DD", days);
      },
    },

    //成果库跳转
    crttid(item) {
      // console.log(item)
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      if (flag) {
        let routeData = this.$router.resolve({
          path: "/fruitDetail",
          query: { id: item.ID },
        });
        window.open(routeData.href, "_blank");
      } else {
        window.location.href =
          this.Urls + "/Mobile/index.html#/AchievementDetail?id=" + item.ID;
        // this.$router.push({
        //   path:
        //     'http://www.nttzzc.com/Mobile/index.html#/AchievementDetail?id=' +
        //     item.ID +
        //     '&Score=' +
        //     5,
        // })
      }
    },
    //登陆成功
    LoginSuccess() {
      let data = {
        action: "Get_UserInfo",
      };
      postAction(library, qs.stringify(data)).then((res) => {
        this.RealName = res.RealName;
        window.localStorage.setItem("RealName", res.RealName);
      });
      this.$router.go(0);
    },
  },
  computed: {
    setstrot() {
      return this.istrue;
    },
    setaleget() {
      return this.taleget;
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 10rem;
}
.datails_nav {
  text-align: left;
  height: 5.125rem;
  line-height: 5.125rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  display: flex;
  align-items: center;
}

.datails_nav .layui-breadcrumb a {
  color: #999 !important;
}

.form {
  width: 45rem;
  height: 2.8rem;
  margin-left: 5.8rem;
  padding-top: 2rem;

  .el-input {
    width: 25rem;

    /deep/ .el-input__inner {
      height: 2.8rem !important;
      padding-left: 1rem;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;

      color: #999999;
      opacity: 1;
    }

    /deep/ .el-input__prefix {
      left: 1.25rem;
    }

    /deep/ .el-input-group__append {
      border: none;
    }

    .el-button--color {
      background: #2769dc;
      border: none;

      height: 2.8rem;
      border-radius: 0 10% 10% 0;

      ::v-deep span {
        font-size: 1.25rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 0rem;
        color: #ffffff;
        opacity: 1;
      }
    }
  }
}

::v-deep .el-form-item {
  margin-right: 0 !important;
}

/deep/ .btn-prev,
.btn-next {
  background-color: #fff !important;
}

.center {
  transform: translateY(-5.75rem);
  width: 87.5rem;
  background-color: #f8fbff;
  margin: 0 auto;
}

.choose {
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  // height: 40.375rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  opacity: 1;
  padding: 2.0625rem 1.625rem;

  .top {
    .line_box {
      margin-bottom: 1.5rem;
      display: flex;
      align-items: baseline;

      .line_box_left {
        min-width: 6.25rem;
        text-align: left;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #4a4a4a;
        padding: 0.5rem 0.96rem;
      }

      .line_box_right {
        display: flex;
        overflow: hidden;
        flex: 1;

        span {
          white-space: nowrap;
          font-size: 1rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          opacity: 1;
          padding: 0.375rem 1.125rem;
          text-align: left;
          cursor: pointer;
        }

        .isActiv {
          cursor: pointer;
          background: #2769dc;
          opacity: 1;
          color: #ffffff;
          border-radius: 0.3125rem;
          line-height: auto;
          padding: 0.375rem 1.125rem;
        }
      }

      .line_wrap {
        flex-wrap: wrap;
      }
    }
  }

  .botm {
    p {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      opacity: 1;

      img {
        width: 0.4375rem;
        height: 0.75rem;
        transform: rotateZ(-90deg);
      }
    }
  }
}

.sort_count {
  display: flex;
  justify-content: space-between;
  height: 4.375rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  opacity: 1;
  margin-top: 1.25rem;
  align-items: center;
  padding-left: 1rem;

  .left {
    display: flex;

    .sortActiv {
      color: #999999;
    }

    span {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #999;
      opacity: 1;
      cursor: pointer;
    }

    .left_sort {
      display: flex;
      align-items: center;

      div {
        cursor: pointer;
        margin-left: 2.3125rem;
      }

      img {
        margin-left: 0.5625rem;
        width: 0.5625rem;
        height: 0.75rem;
      }

      .fanzhuan {
        transform: rotate(180deg);
      }
    }
  }
}

.cenong {
  width: 100%;
  height: auto;
  margin-top: 0.625rem;
  overflow: hidden;
}

.cenong-left {
  float: left;
}

.cenong-right {
  float: right;
  width: 14.375rem;
  height: auto;
  margin-top: 1.875rem;
  padding: 0 0.9375rem;
  box-sizing: border-box;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
}

.cenong-right-top {
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  margin-top: 1.25rem;
  overflow: hidden;
  width: 20.875rem;
  float: right;
}

.crtone {
  height: 5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  position: relative;
}

.crtone-d {
  display: flex;
  font-size: 1.25rem;
  align-items: center;
}

.crtone-d h3 {
  margin-left: 0.3125rem;
}

.crtone-d img {
  height: 1.5625rem;
}

.crtone-g a {
  color: #999;
  font-size: 1.125rem;
  right: 1.5rem;
  bottom: 1.875rem;
  line-height: 0.125rem;
}

.crtt-two {
  color: rgba(208, 208, 208, 1);
}

.crtt-two span {
  color: #f15916;
  font-family: Microsoft YaHei;
}

.crttwo {
  height: 16.625rem;
  border: 0.0625rem solid #eee;
  margin: 0 1.5rem 1.25rem;
  cursor: pointer;
}

.crttwoimg {
  width: 100%;
  height: 9.6875rem;
  background: #333333;
}

.crttwoimg img {
  width: 100%;
  height: 100%;
  float: left;
}

.crttwotext {
  text-align: left;
  padding: 0.7rem;
  line-height: 1.6875rem;
}

.crttwotext div {
  font-size: 1rem;
}

.crttwo-ji {
  color: rgba(208, 208, 208, 1);
  line-height: 2rem;
}

.crttwo-ji span {
  color: #8b8b8b;
}

.cet-cil {
  color: rgba(208, 208, 208, 1);
}

.cet-ciltwo {
  line-height: 2rem;
  color: rgba(208, 208, 208, 1);
}

.cet-span {
  color: rgba(139, 139, 139, 1);
}

.crttwotext .one {
  display: inline-block;
  width: 100%;
  font-size: 1.25rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0.3125rem;
}

.cenong-left-conent {
  margin-top: 1.25rem;
  overflow: hidden;
  padding-top: 1.25rem;
}

.clc-ui {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.clc-ui:after {
  content: "";
  width: 20.6875rem;
}

.clc-ui li {
  width: 20.6875rem;
  float: left;
  border-radius: 2%;
  border-bottom: 4px solid orange;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  min-height: 25.375rem;
  margin-bottom: 1.8125rem;
  cursor: pointer;

  &:hover {
    box-sizing: border-box;
    border-bottom: 4px solid blue;

    .name1 {
      color: #0561d2;
    }

    // background: linear-gradient(to bottom, #409aff, white);
    // background-color: #409aff;
  }
}

.clc-lia {
  position: relative;
  height: 60%;
  overflow: hidden;
  margin-bottom: 1.5625rem;
}

.clcig {
  position: absolute;
  top: 0.5rem;
  right: 0.0625rem;
  z-index: 9;
  width: 9.6875rem;
  height: 9.6875rem;
  background: #fff;
  border-radius: 50%;
}

.clc-lia img {
  z-index: 99;
  width: 9.375rem;
  height: 9.375rem;
  margin: 0.125rem auto 0;
}

.clc-lia-name {
  width: 14rem;
  height: 6.875rem;
  background: #f7f7f7;
  margin-top: 3.125rem;
  text-align: left;
  padding: 1.875rem 1.25rem;
  box-sizing: border-box;
  position: relative;
}

.lihead {
  width: 100%;
  height: 15rem;

  img {
    width: 100%;
    height: 15rem;
    display: block;
  }
}

.tags {
  width: 15rem;
  margin-top: 1rem;
  text-align: left;

  span {
    width: auto;
    padding: 0.2rem;
    color: #0561d2;
    height: 2rem;
    margin-right: 0.5rem;
    border-radius: 5px;
    border: 1.5px solid #0561d2;
  }
}

.brieIfntroduction {
  width: 17.5rem;
  height: 5rem;
  margin-top: 1rem;
  line-height: 1.8;
  text-overflow: ellipsis;
  text-align: left;
  overflow: hidden;
}

.video {
  width: 17rem;
  height: 10rem;
  margin-top: 1.5rem;

  video {
    width: 17rem;
    height: 10rem;
    display: block;
    margin: auto;
  }
}

.gang {
  width: 0.5rem;
  height: 3.25rem;
  position: absolute;
  top: 1.875rem;
  left: -0.17rem;
  background: #0561d2;
}

.clc-lia-name div b {
  display: block;
  font-size: 1.25rem;
  width: 7rem;
  height: 1.875rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.Adminis {
  display: block;
  color: #666;
  // height: 2rem;
}

#elcol {
  padding-right: 0.625rem !important;
}

#elco {
  max-width: 22.5rem !important;
}

.clncol {
  color: #999;
  margin-right: 42px;
}

.xiaoelse {
  text-align: center;
  display: block;
  margin: 0 auto;
}

.xiaoelse img {
  width: 20%;
}

.xiaoelse p {
  margin-top: 1.25rem;
  color: #cccccc;
  text-align: center;
}

.xinging {
  min-width: 1.25rem;
  margin-top: 5px;
}

.xinging span {
  display: inline-block;
  height: 0.9375rem;
  line-height: 0.75rem;
  margin-top: 0.5625rem;
  color: #999;
}

.guanzhi {
  width: 6.3125rem;
  height: 2.1875rem;
  line-height: 2.1875rem;
  color: #fff;
  text-align: center;
  background: #2769dc;
  margin: 1.875rem auto 0;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
}

.iscong {
  color: #333 !important;
}

.stingimg {
  display: inline-block;
  transform: rotateX(180deg);
}

.qunp {
  white-space: nowrap;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  opacity: 1;
  padding: 0.375rem 1.125rem;
  text-align: left;
  cursor: pointer;
  height: 1.5rem;
}

.itemind {
  display: flex;
  flex-wrap: wrap;
}

.el-icon-search {
  color: white;
}

.detail_top_info_box {
  background: #f8fbff;
  display: flex;
  justify-content: center;
  padding-top: 4rem;

  .top_info_box {
    display: flex;
    width: 87.5rem;
    background: #ffffff;

    .top_info_box_left {
      width: 55rem;
      height: 31.5rem;
      background: #000;
      margin: 1.88rem;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .top_info_box_right {
      flex: 1;
      text-align: left;
      margin: 1.88rem 1.88rem 1.88rem 0;

      .top_info_name {
        font-weight: 600;
        font-size: 1.5rem;
        color: #232323;
        line-height: 1.75rem;
        margin-bottom: 1rem;
      }

      .top_info_desc {
        font-size: 0.88rem;
        color: #666666;
        margin-bottom: 0.2rem;

        label {
          color: #9f9f9f;
        }

        span {
          color: #2769dc;
        }
      }

      .top_info_sub_title {
        font-weight: bold;
        font-size: 0.88rem;
        color: #7a7a7a;
        margin-top: 1rem;
        margin-bottom: 0.5rem;
      }

      .top_info_txt {
        font-size: 0.88rem;
        color: #4a4a4a;
        line-height: 1.44rem;
      }

      .top_info_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 6.13rem;
        height: 2.13rem;
        background: #2769dc;
        border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
        font-size: 1rem;
        color: #ffffff;
        margin-top: 2rem;
        cursor: pointer;
      }
    }
  }
}

.detail_body_header {
  width: 100%;
  background-color: #ffffff;

  .detail_body_header_box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 4.09rem;
    font-weight: 600;
    font-size: 1.38rem;
    color: #232323;
    margin: 0 1.88rem;
    border-bottom: 1px solid #e4e4e4;

    span {
      color: #2769dc;
    }

    .detail_tag_box {
      display: flex;
      margin-left: 1rem;
      border: 1px solid #2769dc;
      background: #ffffff;
      border-radius: 0.25rem;

      .tag_item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3.25rem;
        height: 1.5rem;
        font-weight: 400;
        font-size: 0.88rem;
        color: #2769dc;
        cursor: pointer;
      }

      .tag_active {
        background: #2769dc;
        color: #ffffff;
      }
    }
  }
}

.detail_body_info_box {
  display: flex;
  justify-content: center;
  background: #f8fbff;
  padding: 1.88rem 0;

  .body_info_box {
    display: flex;
    width: 87.5rem;
    text-align: left;

    .detail_body_info_left {
      width: 53.75rem;
      height: 36.13rem;
      margin-right: 1.25rem;
      background: #ffffff;
     
      .detail_body_info_content {
        margin: 1.88rem;
      }

      .detail_body_info_txt {
        font-size: 0.88rem;
        color: #4a4a4a;
        line-height: 1.44rem;
        text-indent: 2rem;
        min-height: 17rem;
        overflow-y:auto;
        height: 29rem;
        
      }

      .detail_body_info_sub_title {
        font-weight: bold;
        font-size: 0.94rem;
        color: #7a7a7a;
        margin: 1.88rem 0 0.63rem 0;
      }

      .detail_body_info_file {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 0.88rem;
        color: #4a4a4a;

        .file_name {
          width: 30rem;
        }

        .file_oper {
          display: flex;
          font-weight: 400;
          font-size: 0.81rem;
          color: #046ee6;

          .file_oper_btn {
            margin-right: 1rem;
            cursor: pointer;
          }
        }
      }
    }

    .detail_body_info_right {
      flex: 1;
      height: 100%;
      background-color: #ffffff;
    }
  }
}

.answer_box {
  background: #ffffff;
  margin: 1.88rem;
  height: 28.13rem;
  overflow-y:auto; /* 当内容超出高度时显示滚动条 */
  .answer_item {
    display: flex;

    .answer_avatar {
      margin-right: 0.63rem;

      img {
        width: 2.25rem;
        height: 2.25rem;
      }
    }

    .answer_content {
      flex: 1;

      .answer_top {
        display: flex;
        align-items: center;
        height: 2.25rem;

        .answer_name {
          font-weight: 600;
          font-size: 1.13rem;
          color: #232323;
        }

        .answer_time {
          font-weight: 400;
          font-size: 0.81rem;
          color: #999999;
          margin-left: 1.44rem;
        }
      }

      .answer_txt {
        font-weight: 400;
        font-size: 0.88rem;
        color: #7a7a7a;
        margin-bottom: 0.5rem;
      }

      .answer_reply_btn_gray {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        width: 2.75rem;
        height: 1.5rem;
        background: #f0f0f0;
        border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
        font-weight: 400;
        font-size: 0.81rem;
        color: #232323;
        margin: 0.7rem 0;
      }

      .answer_reply_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 0.81rem;
        color: #ffffff;
        width: 3.13rem;
        height: 1.5rem;
        background: #2769dc;
        border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
        margin: 0.63rem 0 1.56rem 0;
        cursor: pointer;
      }
    }
  }
}

.about_info_box {
  width: 87.5rem;
  height: 33.69rem;
  background: #ffffff;
  .about_box {
    display: flex;
    flex-wrap: wrap;
    margin: 0 1.88rem;
    .about_item {
      display: flex;
      margin-right: 3.13rem;
      margin-top: 2.13rem;
      cursor: pointer;
      &:nth-child(2n) {
        margin-right: 0;
      }
      .about_item_img {
        margin-right: 1.25rem;
        img {
          width: 20.63rem;
          height: 11.81rem;
          border-radius: 0.38rem 0.38rem 0.38rem 0.38rem;
        }
      }
      .about_item_content {
        width: 18.13rem;
        text-align: left;
        .about_item_title {
          font-weight: 600;
          font-size: 1.13rem;
          color: #232323;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          min-height: 3.13rem;
          margin-bottom: 0.5rem;
        }
        .about_item_desc {
          font-weight: 400;
          font-size: 0.81rem;
          color: #9f9f9f;
          margin-bottom: 0.94rem;
        }
        .about_item_txt {
          font-weight: 400;
          font-size: 0.88rem;
          color: #7a7a7a;
          line-height: 1.44rem;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          min-height: 4.32rem;
        }
      }
    }
  }
}

::v-deep .open_more_dialog_box {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .open_more_dialog {
    .open_more_dialog_top {
      width: 40rem;
      height: 10.44rem;
      background: linear-gradient(
        180deg,
        #4d8eff 0%,
        #6ba2ff 46%,
        #b5d0ff 100%
      );
      font-weight: 600;
      font-size: 1.88rem;
      color: #ffffff;
      text-align: center;

      .open_more_dialog_name {
        padding-top: 3.5rem;
      }

      &:before {
        top: 8.36rem;
        left: 0;
        right: 0;
        width: 100%;
        border-radius: 50%; // 控制弧度效果 越大弧度越自然
        background: #ffffff;
        content: "";
        height: 4rem; // 控制椭圆高度
        position: absolute; // 关键***
      }
    }

    .open_more_dialog_footer {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40rem;
      height: 4.69rem;
      background: #ffffff;
      box-shadow: 0rem -0.25rem 0.63rem 0.06rem rgba(39, 105, 220, 0.1);

      .open_more_dialog_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12.13rem;
        height: 2.13rem;
        background: linear-gradient(90deg, #4d8eff 0%, #b5d0ff 100%);
        border-radius: 1.06rem 1.06rem 1.06rem 1.06rem;
        font-size: 0.94rem;
        color: #ffffff;
        cursor: pointer;
      }
    }

    .open_more_dialog_body {
      padding: 1rem 2.5rem 0 2.5rem;
      text-align: left;
      font-size: 0.94rem;
      color: #1e232d;
      line-height: 1.88rem;

      .el-input__inner,
      .el-textarea__inner {
        background: #f8fbff;
      }
      /* 通过CSS变量改变placeholder颜色 */
      .el-input__inner::-webkit-input-placeholder {
        color: var(--placeholder-color, #7a7a7a); /* 默认颜色 */
      }
      .el-input__inner::-moz-placeholder {
        color: var(--placeholder-color, #7a7a7a); /* Firefox 19+ */
      }
      .el-input__inner:-ms-input-placeholder {
        color: var(--placeholder-color, #7a7a7a); /* IE 10+ */
      }
      .el-input__inner::-ms-input-placeholder {
        color: var(--placeholder-color, #7a7a7a); /* Edge */
      }
      .el-input__inner::placeholder {
        color: var(--placeholder-color, #7a7a7a); /* 标准浏览器 */
      }
      /* 通过CSS变量改变placeholder颜色 */
      .el-textarea__inner::-webkit-input-placeholder {
        color: var(--placeholder-color, #7a7a7a); /* 默认颜色 */
      }
      .el-textarea__inner::-moz-placeholder {
        color: var(--placeholder-color, #7a7a7a); /* Firefox 19+ */
      }
      .el-textarea__inner:-ms-input-placeholder {
        color: var(--placeholder-color, #7a7a7a); /* IE 10+ */
      }
      .el-textarea__inner::-ms-input-placeholder {
        color: var(--placeholder-color, #7a7a7a); /* Edge */
      }
      .el-textarea__inner::placeholder {
        color: var(--placeholder-color, #7a7a7a); /* 标准浏览器 */
      }
    }
  }
}
.commentList {
  width:30rem;
  margin-left: 1rem;
  text-align: left;
  li {
    margin-bottom: 1rem;
    background: rgba(249, 249, 249, 0.39);
    margin-bottom: 1.25rem;
    .op {
        display: flex;
        align-items: center;
        width: 20rem;
        height: 2.25rem;
     
        .answer_name {
          font-weight: 600;
          font-size: 1.13rem;
          color: #232323;
        }

        .answer_time {
          font-weight: 400;
          font-size: 0.81rem;
          color: #999999;
          margin-left: 1.44rem;
        }
      }

      .txt {
        font-weight: 400;
        font-size: 0.88rem;
        color: #7a7a7a;
        
        margin-bottom: 0.5rem;
      }
  }
}
.islike {
  display: flex;
  margin-left: 1.55rem;
  margin-bottom: 1.25rem;
  .goodjob {
    img {
      width: 14px;
      margin-right: 5px;
      vertical-align: middle;
    }
  }
  .comment {
    margin-right: 21px;
    img {
      vertical-align: middle;
      width: 14px;
      margin-right: 5px;
    }
  }
}
.commentName {
  color: #2a3457;
  font-size: 1rem;
  font-family: Microsoft YaHei;
}
.commentTime {
  margin-top: 0.5rem;
  margin-left: 1rem;
  color: #9fa3b3;
  font-size: 1rem;
  font-family: Microsoft YaHei;
}
.commentText {
  color: #9fa3b3;
}
</style>
